<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-left: 15px;">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>出库维护</el-breadcrumb-item>
            <el-breadcrumb-item>出库管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card style="height: 100%;">
            <el-row :gutter="0">
                <el-col :span="6"  >
                    <el-input placeholder="请输入查询内容" v-model="queryInfo.query" class="input-with-select" clearable
                        style="width:300px " @clear="getChukuList" @change="getChukuList">
                        <el-button slot="append" icon="el-icon-search" @click="getChukuList"></el-button>

                    </el-input> <el-button type="primary" @click="chukuAdd" v-if="false">入库</el-button>
                    <el-button type="primary" @click="chukuAdd" v-if="xiugai_type == 1">出库</el-button>
                </el-col>
                <el-col :span="6"  >
                    <el-button type="primary" @click="get_product_add" v-if="false">出库清单</el-button>
                </el-col>
                <el-col :span="12"  style="text-align: right;" >
                    <el-button type="primary" @click="handleExport()">导出电子表格</el-button>
                </el-col>
            </el-row>
            <el-row :gutter="0" class="el_row_two">
                <el-col :span="24">
                    <el-table :data="productList" style="width: 100%" border stripe id="report">
                        <el-table-column type="expand">
                            <template slot-scope="scope">
                                <el-table :data="scope.row.list" stripe>
                                    <el-table-column width="80" label="序号"> <template slot-scope="scope">{{ scope.$index
                                    }}</template>
                                    </el-table-column>
                                    <el-table-column prop="pro_uid" label="商品序号" width="200"> </el-table-column>
                                    <el-table-column prop="pro_name" label="商品名称" width="200"> </el-table-column>
                                    <el-table-column label="商品类别" width="300">
                                        <template slot-scope="scope">{{ scope.row.leixing01 }}:{{ scope.row.leixing02 }}:{{
                                            scope.row.leixing03 }}:{{ scope.row.leixing04 }}</template>
                                    </el-table-column>
                                    <el-table-column prop="pro_count" label="商品数量" show-overflow-tooltip>
                                    </el-table-column>
                                </el-table>
                            </template>
                        </el-table-column>
                        <el-table-column prop="uid" label="序号" width="60"></el-table-column>
                        <el-table-column prop="chuku_bianhao" label=" 编号"></el-table-column>
                        <el-table-column prop="chuku_date" label="时间"></el-table-column>
                          <el-table-column prop="qiye_bianhao" label="编号"></el-table-column>
                          <el-table-column prop="qiye_name" label="门店"></el-table-column>
                        <!-- <el-table-column label="操作">
                            <template v-slot="scope">
                            
                                <el-button
                                    @click="kucun_chuku_show(scope.row.uid,scope.row.chuku_bianhao)"
                                    type="primary" plain style="margin-left: 20px;">查看明细</el-button>
                            </template>
                        </el-table-column> -->

                    </el-table>
                </el-col>
            </el-row>

            <!-- 分页 -->
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page.sync="queryInfo.pageNum" :page-sizes="[10, 50]" :page-size="queryInfo.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
                <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
            </el-pagination>
            <el-dialog title="出库明细" :visible.sync="chukuShowDialogVisible" width="90%" @close="addDoalogClosed">
                <chukuShow :chukudanUid="chukudanUid" :chukudanBianhao="chukudanBianhao" :key="datekey"> </chukuShow>
            </el-dialog>
            <el-dialog title="出库" :visible.sync="chukuDialogVisible" width="90%" @close="addDoalogClosed">
                <chukuAdd @chuku_addClose="chuku_addClose" ref="chukuAddRef"> </chukuAdd>
                <!-- <chukuDo :dataParent="addForm" ref="chukuDoRef" :diaoyongType="1" @closeAdd="closeAdd" :key="datekey"> </chukuDo> -->
            </el-dialog>
        </el-card>
    </div>
</template>
<script>
import { checkMobileTest, checkSfzId } from './config/validator'
import exportExcel from './config/exportExcel'
import chukuAdd from './module/chuku_add.vue'
import chukuShow from './module/chuku_show.vue'
export default {
    components: {
        chukuAdd: chukuAdd,
        chukuShow: chukuShow
    },
    props: ['xiugai_type', 'qiye_uid', 'show_type'], // xiugai_type 1  操作  2 显示 qiye_uid qiye_uid  企业uid ，显示模式show_type 全部显示，只显示制定企业uid部分
    data() {
        return {
            datekey: Date.now(),
            rukuDialogVisible: false,
            chukuDialogVisible: false,
            rukuShowDialogVisible: false,
            chukuShowDialogVisible: false,
            chukudan_bianhao: '',
            kucunAddData: [],
            kucunAddData_proUid: [],
            chukudanUid: 0,
            chukudanBianhao: '',

            // 获取用户列表参数
            queryInfo: {
                C_type: 'get_list_more',
                C_table_name: 'chuku_list_more',
                query: '',
                pageNum: 1,
                pageSize: 10,
                CI_canshu01: this.show_type,
                CI_canshu02: 0
            },
            productList: [],
            //  recordCount: 0,
            total: 0,
            addForm: {
                kaidanFlag: 0,
                guest_info: {
                    guest_level: 0
                    // 开单调用标记 为 0 ，在下一个页面做识别
                }
            },

            // 表单规则项
            addFormRules: {

            },

            editFormRules: {

            }
        };
    },
    created() {
        this.getChukuList()
        // this.chukudan_bianhao_get()
    },
    methods: {
        handleExport() {
            exportExcel('report', '导出.xlsx')
        },
        chuku_addClose() {
            this.chukuDialogVisible = false
        },
        closeAdd() {
            this.chukuDialogVisible = false
            this.getChukuList()
        },
        chukuAdd() {
            this.datekey = Date.now()
            this.chukuDialogVisible = true
        },
        addDoalogClosed() {
            this.getChukuList()
        },

        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        kucun_chuku_show(chukudanUid, chukudanBianhao) {
            this.chukudanUid = chukudanUid
            this.chukudanBianhao = chukudanBianhao
            this.datekey = Date.now()
            this.chukuShowDialogVisible = true
        },

        async getChukuList() {
            const { data: res } = await this.$http.get('get_api', {
                params: this.queryInfo
            });
            console.log(JSON.parse(res.data)[0].dataList)
            this.productList = JSON.parse(res.data)[0].dataList

            if (!this.productList) return;
            this.productList.forEach(function (item) {
                item.yong_flag = item.yong_flag === 1;
            });

            this.total = JSON.parse(res.data)[0].total;

            // console.log(this.total)
        },
        //  分页第一项下拉触发

        handleSizeChange(newSize) {
            this.queryInfo.pageSize = newSize;
            this.getChukuList();
        },
        // 选择页数触发
        handleCurrentChange(newPage) {
            this.queryInfo.pageNum = newPage;
            this.getChukuList();
        }
    }
}
</script>
<style lang="less" scoped>
.card_two {
    margin-top: 30px;
    box-shadow: none !important;
    background-color: #f2f6fc;
}

.el_row_two {
    margin-top: 30px;
}
</style>
